import * as Yup from 'yup'
import { filter, get, isEmpty } from 'lodash'

import { stakeholderEmailValidateRegex } from './constants'
import { emptyFieldMessage } from './messagesContants'

type CustomStakeholder = {
  email: string
}
declare module 'yup' {
  interface ArraySchema<T> {
    uniqueProperty(propertyPath: string, message?: string): ArraySchema<T>
    installmentsValidation(
      propertyPath: string,
      message?: string
    ): ArraySchema<T>
  }
}

Yup.addMethod(Yup.array, 'uniqueProperty', function (propertyPath, message) {
  return this.test('unique', '', function (list: any) {
    const errors: any = []

    list?.forEach((item: any, index: number) => {
      const propertyValue = get(item, propertyPath)

      if (
        propertyValue &&
        filter(list, [propertyPath, propertyValue]).length > 1
      ) {
        errors.push(
          this.createError({
            path: `${this.path}[${index}].${propertyPath}`,
            message,
          })
        )
      }
    })

    if (isEmpty(errors)) {
      throw new Yup.ValidationError(errors)
    }

    return true
  })
})

export const metaDataItemValidationSchema = Yup.object().shape({
  key: Yup.string(),
  value: Yup.string(),
})

metaDataItemValidationSchema.fields.key =
  metaDataItemValidationSchema.fields.key.when('value', {
    is: (value: string) => value && value.trim().length > 0,
    then: Yup.string().required(emptyFieldMessage),
    otherwise: Yup.string(),
  })

metaDataItemValidationSchema.fields.value =
  metaDataItemValidationSchema.fields.value.when('key', {
    is: (key: string) => key && key.trim().length > 0,
    then: Yup.string().required(emptyFieldMessage),
    otherwise: Yup.string(),
  })

export const offerStakeholdersValidation = {
  offerStakeholders: Yup.array()
    .of(
      Yup.object().shape({
        email: Yup.string().required('Email cannot be empty.'),
      })
    )
    .min(1, 'At least one stakeholder is required.'),

  customOfferStakeholders: Yup.array().test(
    'Enter-valid-emails',
    'Enter valid emails.',
    function (value?: CustomStakeholder[]) {
      if (!value) return true
      return value?.every(v => stakeholderEmailValidateRegex.test(v.email))
    }
  ),
}
